module.exports = "<button (click)=\"openConfig.emit()\" class=\"config-panel-toggle\" mat-fab type=\"button\">\n  <mat-icon>settings</mat-icon>\n</button>\n"